<template>
  <svg
    class="small-spinner"
    :style="{
      width: sideSize,
      height: sideSize
    }"
    :viewBox="viewBoxParam"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="small-spinner-circle"
      :cx="centerOffset"
      :cy="centerOffset"
      :r="radius"
      :stroke-width="strokeWidth"
      :stroke-dasharray="dashArray"
      fill="none"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script>
  export default {
    name: 'SmallSpinner',
    props: {
      radius: {
        type: Number,
        default: 5.5
      },
      strokeWidth: {
        type: Number,
        default: 1.5
      }
    },
    data () {
      return {
        animation: null
      };
    },
    computed: {
      viewBoxParam () {
        const width = this.radius * 2 + this.strokeWidth * 2;
        return `0 0 ${width} ${width}`;
      },
      dashArray () {

        // loader length
        return this.radius * 6.28 * 0.75;
      },
      centerOffset () {
        return this.radius + this.strokeWidth;
      },
      sideSize () {
        return `${this.centerOffset * 2}px`;
      }
    }
  };
</script>

<style>
  .small-spinner {
    animation: rotation 1000ms cubic-bezier(0.26, 0.05, 0.24, 0.85) infinite;
    stroke: var(--panel-text-color);
  }

  .small-spinner-circle {
    stroke-linecap: round;
  }

  @keyframes rotation {
    100% {
      transform: rotate(360deg);
    }
  }
</style>
